import { render } from "./SmartZone.vue?vue&type=template&id=8272a6a4&scoped=true&ts=true"
import script from "./SmartZone.ts?vue&type=script&lang=ts"
export * from "./SmartZone.ts?vue&type=script&lang=ts"

import "./SmartZone.vue?vue&type=style&index=0&id=8272a6a4&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8272a6a4"]])

export default __exports__